import {Component} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ImageTypeEnum} from '../../graphql/globalTypes';

@Component({
  selector: 'app-video-display',
  templateUrl: './content-display.component.html',
  styleUrls: ['./content-display.component.scss'],
  standalone: false,
})
export class ContentDisplayComponent {
  url = '';
  type: ImageTypeEnum | null = null;
  ImageTypeEnum = ImageTypeEnum;

  constructor(public bsModalRef: BsModalRef) {}

  closeModal(): void {
    this.bsModalRef.hide();
  }
}
